import { render, staticRenderFns } from "./vPartsWithDocuments.vue?vue&type=template&id=a19b1218"
import script from "./vPartsWithDocuments.vue?vue&type=script&lang=js"
export * from "./vPartsWithDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports